import type { TAiChatToolName } from '../interfaces/IAiChatTools';

/**
 * The tools whose call is a display slot: the component is the output, drawn inline in the reply
 * like a paragraph of it, not as a step of the call chain. No step row, no icon, no connector.
 * A call that showed nothing is the one exception: it is a step the model goes on from, and
 * `AiChatDisplayFailed` draws it as one.
 *
 * A tool listed here must have a component in `TOOL_COMPONENTS`, kept under
 * `components/displayTools/`. Every other tool is a work step and renders in the step row.
 *
 * @see [11.5 Tool calls on the frontend](../../../../docs/mockups/ai-agents/ai-chat/ATT-144_AI_Chat_Assistant.md)
 */
const DISPLAY_TOOLS: ReadonlySet<TAiChatToolName> = new Set<TAiChatToolName>(['showDatasource', 'showChart']);

/** Whether a tool draws its output inline rather than as a step. Any name, known or not. */
export const isDisplayTool = (name: string): boolean => DISPLAY_TOOLS.has(name as TAiChatToolName);

export default DISPLAY_TOOLS;
